import { useTheme } from "styled-components";
export const useChroma = () => {
    return useTheme()?.skin || {};
};
//# sourceMappingURL=useChroma.js.map